<template>
  <v-card class="tw-flex tw-justify-center" flat>
    <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8 tw-py-2 md:tw-py-8">
      <p class="c-blue-text">Please click the link below to proceed with the payment.</p>
      <div v-if="browserIsSafari()" class="tw-bg-blue-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
        <p>You're using Safari browser, you might be needed to login after the card payment to complete payment after redirect due to cookie policies</p>
      </div>
      <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
        <v-btn block large
               color="secondary"
               class="my-3"
               :loading="loading"
               @click="initiateInterswitch"
        >
          Pay with Card
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
import { FB_BUY_PAYMENT_CARD_INIT } from '@/utils/const';

export default {
  name: 'CardPayment',
  props: ['data'],
  data() {
    return {
      loading: false,
    };
  },
  metaInfo: {
    title: 'Card Payment',
  },
  methods: {
    initiateInterswitch() {
      this.$analytics.logEvent(FB_BUY_PAYMENT_CARD_INIT);
      this.loading = true;
      const name = this.data.quoteInfo.client.fullName.split(' ');
      const firstName = name[0];
      const lastName = name.length > 1 ? name[1] : name[0];
      const quote = this.$route.query.q;
      const benefit = this.$route.query.b;
      let queryParam = '';
      if ((!!quote && !!benefit)) {
        queryParam = `q=${quote}&b=${benefit}&buy=1`;
      } else {
        const { policyNo, batchNo } = this.$route.params;
        queryParam = `policyNo=${policyNo}&batchNo=${batchNo}&buy=0`;
      }

      const accountRef = this.data.payment.accountReference.replace(' ', '');
      const paymentValues = {
        amount: this.data.payment.payableAmount * 100,
        channel: 'WEB',
        currencyCode: 'KES',
        customerInfor: `${this.data.quoteInfo.client.idNumber}|${firstName}|${lastName}|${this.data.quoteInfo.client.email}|${this.data.quoteInfo.client.mobileNumber}|NBI|KE|00200||NBI`, // |NBI|KE|00200|wstlnds|NBI|41.215.3.130|kelvin-pc|mozilla ',
        domain: 'ISWKE',
        fee: '0',
        iconUrl: 'https://www.apainsurance.org/img/logon.png',
        merchantCode: process.env.VUE_APP_IS_MERCHANT_CODE,
        narration: accountRef,
        orderId: `${this.data.payment.description}-${this.makeId()}`,
        preauth: '0',
        redirectUrl: `${process.env.VUE_APP_BASE_URL}/card-response?${queryParam}&desc=${this.data.payment.description}&accountRef=${accountRef}`,
        terminalId: process.env.VUE_APP_IS_TERMINAL_ID,
        transactionReference: this.makeId(),
      };

      const form = document.createElement('form');
      document.body.appendChild(form);
      form.method = 'post';
      form.action = `${process.env.VUE_APP_IS_BASE_URL}/webpay/checkout`;
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const paymentValue in paymentValues) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = paymentValue;
        input.value = paymentValues[paymentValue];
        form.appendChild(input);
      }
      form.submit();
    },
    makeId(length = 12) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < length; i++) {
        // Use crypto API instead of Math.random()
        const randomBuffer = new Uint8Array(1);
        window.crypto.getRandomValues(randomBuffer);
        result += characters.charAt(randomBuffer[0] % charactersLength);
      }
      return result;
    },
    browserIsSafari() {
      // eslint-disable-next-line func-names
      return /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]'; }(!window.safari || (typeof safari !== 'undefined' && window.safari.pushNotification)));
    },
  },
};
</script>
